import { defineStore } from 'pinia'

export const useMSUserStore = defineStore('ms-user', {
  state: () => ({
    account: null, // Holds the current user MS account
  }),
  actions: {
    setAccount(msAccount) {
      this.account = msAccount
    },
    clear() {
      this.account = null
    },
  },
  getters: {
    name: (state) => state.account?.name,
    email: (state) => state.account?.username,
    isLoggedIn: (state) => !!state.account,
  },
})
